import {soulAddress, soulDetailAddress, KogeAddress, govBNBAddress, nftAddress} from './addresses'
import soulAbi from './abis/soul.json'
import soulDetailAbi from './abis/soulDetail.json'
import kogeAbi from './abis/koge.json'
import govBNBAbi from './abis/govBNB.json'
import nftAbi from './abis/nft.json'

export const soulContract = {
  address: soulAddress,
  abi: soulAbi,
} as const

export const soulDetailContract = {
  address: soulDetailAddress,
  abi: soulDetailAbi,
} as const

export const kogeContract = {
  address: KogeAddress,
  abi: kogeAbi,
} as const

export const govBNBContract = {
  address: govBNBAddress,
  abi: govBNBAbi,
} as const

export const nftContract = {
  address: nftAddress,
  abi: nftAbi,
} as const